import {SpavaObj} from './SpavaObj'

class Template extends SpavaObj {
  static SMS = 'sms'
  static WECHAT = 'wechat'
  static EMAIL = 'email'

  name
  text
  code
  module
  variantList = []
  type

  constructor (o) {
    super(o)
    if (!(o instanceof Object)) {
      o = {}
    }
    this.name = o.name || ''
    this.text = o.text || ''
    this.code = o.code || ''
    this.module = o.module || ''
    this.type = o.type || null
    this.variantList = o.variantList || []
  }
  static fromAPI (o) {
    o.text = o.originalTemplate
    return new Template(o)
  }
}

export {
  Template
}
